// libs/core/src/lib/async/async-frame.ts
function asyncFrame() {
  return new Promise((resolve) => requestAnimationFrame(resolve));
}

// libs/core/src/lib/async/async-timeout.ts
function asyncTimeout(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
export {
  asyncFrame,
  asyncTimeout
};
//# sourceMappingURL=index.esm.js.map
